export default class AlUserGridEntryController {

    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.alert = this.injector.get('Alert');
        this.state = this.injector.get('$state');
        this.translate = this.injector.get('$translate');
        this.api = this.injector.get('$http');
        this.userStore = this.injector.get('Users');
        this.uibModal = this.injector.get('$uibModal');
        this.usersStore = this.injector.get('Users');
        this.acl = this.injector.get('Acl');

        this.user = null;
        this.onTriggerReload = () => {
        };

        this.userInformation = {
            roles: [],
            status: 'active'
        };
        this.statusInformation = null;
        this.actions = [];
        this.statLabels = [];

        this.fileSelectionTrigger = null;
        this.landingpageEnabled = false;

        this.canEdit = this.acl.hasRight('users::edit');
        this.canArchive = this.acl.hasRight('users::archive');
        this.canDelete = this.acl.hasRight('users::delete');
    }


    $onInit() {
        this._updateUserInformation();
        this._initWatchers();
    }

    editUser() {
        this.state.go('app.users.edit', {
            id: this.user.id
        })
    }

    deleteUser() {
        this.alert
            .animatedAlert(
                this.translatedValue('user.delete.alert.confirm.title'),
                this.translatedValue('user.delete.alert.confirm.description'),
                'attention',
                {
                    confirmBtn: this.translatedValue('user.delete.alert.confirm.yes'),
                    wait: true
                }
            )
            .then(() => {

                this.api
                    .delete(`users/${this.user.id}`, {
                        data: {force: true}
                    })
                    .then(() => {
                        this.alert.success(
                            this.translatedValue('user.delete.alert.success.title'),
                            this.translatedValue('user.delete.alert.success.description'),
                        );
                        this.alert.hide();
                        this.onTriggerReload();
                    })
                    .catch(response => {
                        this.alert.error(
                            this.translatedValue('user.delete.alert.error.title'),
                            response.data.message
                        );
                    });
            });
    }

    archiveUser() {
        this.alert
            .animatedAlert(
                this.translatedValue('user.archive.alert.confirm.title'),
                this.translatedValue('user.archive.alert.confirm.description'),
                'attention',
                {
                    confirmButtonText: this.translatedValue('general.verbs.yes'),
                    cancelButtonText: this.translatedValue('general.verbs.no'),
                    wait: true,
                },
            )
            .then(() => {
                this.api
                    .delete('users/' + this.user.id)
                    .then(response => {
                        this.user = response.data.data;
                        this.alert.hide();
                        this.onTriggerReload();

                        return this.alert.success(
                            this.translatedValue('user.archive.alert.success.title'),
                            this.translatedValue('user.archive.alert.success.description'),
                        );
                    })
                    .catch((response) => {
                            this.alert.error(
                                this.translatedValue('user.archive.alert.error.title'),
                                response.data.message
                            )
                        }
                    )
            })
    }

    restoreUser() {
        this.alert
            .animatedAlert(
                this.translatedValue('user.restore.alert.confirm.title'),
                this.translatedValue('user.restore.alert.confirm.description'),
                'attention',
                {
                    confirmBtn: this.translatedValue('general.verbs.yes'),
                    wait: true,
                }
            )
            .then(() => {
                this.api.put(`users/${this.user.id}/restore`)
                    .then(response => {
                        this.user = response.data.data;
                        this.alert.hide();

                        this.onTriggerReload();
                        this.alert.success(
                            this.translatedValue('user.restore.alert.success.title'),
                            this.translatedValue('user.restore.alert.success.description'),
                        );
                    })
                    .catch(response => {
                        this.alert.error(
                            this.translatedValue('user.restore.alert.error.title'),
                            response.data.message
                        );
                    });
            });
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.user,
            () => {
                this._updateUserInformation();
            }
        )
    }

    _updateUserInformation() {
        if (!this.user) {
            return;
        }


        this.userInformation.roles = this.user.role ? this.user.role.split(', ') : [];

        if (this.user.deleted_at) {
            this.userInformation.status = 'archived';
        } else if (this.user.master_user.status === 'activated') {
            this.userInformation.status = 'activated';
        } else if (this.user.master_user.status === 'deactivated') {
            this.userInformation.status = 'inactive';
        } else {
            this.userInformation.status = 'pending';
        }
    }

    translatedValue(path, params) {
        return this.translate.instant(path, params);
    }
}

AlUserGridEntryController
    .$inject = [
    '$scope',
    '$injector'
]



// WEBPACK FOOTER //
// ./src/app/modules/users/components/al-users-grid-view/sub-components/al-user-grid-entry/controller.js